export default __webpack_public_path__ + "static/media/down_grey_icon.553d53d9.svg";